module.exports = __webpack_public_path__ + "static/img/cimb.659730f2.svg";